/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  // Check if printer has been set or not
  if (localStorage.getItem("printercounterfeit") == "" || localStorage.getItem("printercounterfeit") == undefined || localStorage.getItem("printercounterfeit") == null) localStorage.setItem("printer", 0); // Check if printer has been set or not

  if (localStorage.getItem("paperSize") == "" || localStorage.getItem("paperSize") == undefined || localStorage.getItem("paperSize") == null) localStorage.setItem("paperSize", 0);

  var printMyText = function printMyText() {
    var data = window.data;
    var printText = "";
    var print80Line = "";
    if (localStorage.getItem("paperSize") == 1) print80Line = "_________________";
    printText += "{BR}";

    if (window.copy == true) {
      if (window.lang == "tl") printText += "{H}KOPIA{/H}";else printText += "{H}COPY{/H}";
      if (localStorage.getItem("printerName") == "MTP-III") printText += "{BR}";else printText += "{BR}{BR}{BR}";
      if (window.lang == "tl") printText += "Asina:" + "____________________";else printText += "Sign:" + "____________________";
      printText += "{BR}{BR}";
    }

    if (window.lang == "tl") printText += "{S}Hameno ID:" + data.orderID + "{/S}{BR}";else printText += "{S}Order:" + data.orderID + "{/S}{BR}";
    if (window.lang == "tl") printText += "{S}Data:" + data.dateTime + "{/S}{BR}";else printText += "{S}Date:" + data.dateTime + "{/S}{BR}"; //printText += print80Line + "___________________________";

    window.DatecsPrinter.printText(printText, 'ISO-8859-1'); //data.receipt.length

    for (var i = 0; i < data.receipt.length; i++) {
      printText = "";
      printText += "{LEFT}";
      window.DatecsPrinter.printText("{BR}  " + data.receipt[i].draw, 'ISO-8859-1');

      for (var j = 0; j < data.receipt[i].details.length; j++) {
        var amountType = "";
        var amountCount = 0;

        for (var k = 0; k < data.receipt[i].details[j].amount.length; k++) {
          var numberType = data.receipt[i].details[j].amount[k].type;
          var numberValue = data.receipt[i].details[j].amount[k].value;
          numberValue = numberValue.replace(" ", "");
          var tab = "";
          if (numberType.length == 1) tab = "    ";
          if (numberType.length == 2) tab = "   ";
          if (numberType.length == 3) tab = "  ";
          amountType += tab + numberType + "-" + numberValue;
          amountCount++;

          if (localStorage.getItem("paperSize") == 0 && data.receipt[i].details[j].type == "SL" && amountCount == 2) {
            amountType += "{BR}";
          }
        }

        var tabnumber = "";
        if (data.receipt[i].details[j].number.length == 4) tabnumber = " ";
        if (data.receipt[i].details[j].number.length == 3) tabnumber = "  ";
        if (data.receipt[i].details[j].number.length == 2) tabnumber = "   ";
        if (localStorage.getItem("printerName") == "MTP-III") printText += "{BR}{H}  " + data.receipt[i].details[j].type + " {B}" + data.receipt[i].details[j].number + "{B}" + tabnumber;else printText += "{BR}{BR}{H}  " + data.receipt[i].details[j].type + " {B}" + data.receipt[i].details[j].number + "{B}" + tabnumber;
        if (data.receipt[i].details[j].position != "") printText += "  " + data.receipt[i].details[j].position + "";else printText += "      ";
        printText += "{/H}";

        if (localStorage.getItem("paperSize") == 0 || data.receipt[i].details[j].type == "SL") {
          if (localStorage.getItem("printerName") == "MTP-III") printText += "{BR}";else printText += "{BR}{BR}";
        }

        printText += amountType;
      }

      window.DatecsPrinter.printText(printText, 'ISO-8859-1');
    }

    window.DatecsPrinter.printText("{BR}{CENTER}" + print80Line + "___________________________{BR}", 'ISO-8859-1');
    window.DatecsPrinter.printText("{H}{B}{RIGHT}PAID: $" + parseFloat(data.total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + "   {/B}{/H}", 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}{CENTER}", 'ISO-8859-1'); //window.DatecsPrinter.printText("{BR}{CENTER}"  + print80Line + "___________________________{BR}", 'ISO-8859-1'); 

    window.DatecsPrinter.printText("{LEFT}", 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}   GDP:" + data.GDP, 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}   " + data.gd4dJP, 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}   " + data.gd6dJP, 'ISO-8859-1');

    for (var i = 0; i < data.gd6DJPNumber.length; i++) {
      window.DatecsPrinter.printText("{BR}   " + data.gd6DJPNumber[i].date, 'ISO-8859-1');
      var countBreak = 3;
      var countToBreak = 0;
      if (print80Line != "") countBreak = 4;
      window.DatecsPrinter.printText("{BR}", 'ISO-8859-1');

      for (var j = 0; j < data.gd6DJPNumber[i].number.length; j++) {
        countToBreak++;

        if (countToBreak > countBreak) {
          window.DatecsPrinter.printText("{BR}", 'ISO-8859-1');
          countToBreak = 1;
        }

        window.DatecsPrinter.printText("   " + data.gd6DJPNumber[i].number[j], 'ISO-8859-1');
      }
    }

    if (data.promotionTitle != "" && data.promotionTitle != null) {
      var promo = "{BR}{BR}   " + data.promotionTitle;

      for (var p = 0; p < data.promotionNumber.length; p++) {
        promo += "{BR}   (" + data.promotionNumber[p].date + ") ";
        var countPromo = 0;

        for (var q = 0; q < data.promotionNumber[p].number.length; q++) {
          countPromo++;

          if (countPromo == 4) {
            promo += "{BR}   (" + data.promotionNumber[p].date + ") ";
            countPromo = 0;
          }

          promo += data.promotionNumber[p].number[q] + " ";
          console.log(data.promotionNumber[p].number[q]);
        }

        promo += "{BR}";
      }

      window.DatecsPrinter.printText(promo, 'ISO-8859-1');
    }

    window.DatecsPrinter.printText("{BR}{CENTER}", 'ISO-8859-1'); // if(window.service == "agent")
    // $f7.views.current.router.navigate("/cashier_pay/");
    // else

    if (localStorage.getItem("paperSize") == 0) printMyBarcode(data.eanCode);else printMyBarcode(data.orderID);
  };

  var printMyImage = function printMyImage() {
    var image = new Image();
    image.src = 'static/images/gd.jpg';

    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.height = 100;
      canvas.width = 100;
      var context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

      window.DatecsPrinter.printImage(imageData, //base64
      canvas.width, canvas.height, 1, function () {
        //window.DatecsPrinter.printText("{BR}{CENTER}", 'ISO-8859-1');
        printMyQR();
      });
    };
  };

  var printMyQR = function printMyQR() {
    var qrcodejs = new QRCode("qrcode", {
      text: window.data.orderID,
      width: 150,
      height: 150,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H
    }); //var image = new Image();
    //image.src = "https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl="+window.data.orderID+"&choe=UTF-8";
    //image.onload = function() {
    //var canvas = document.createElement('canvas');
    //canvas.height = 300;
    //canvas.width = 300;
    //var context = canvas.getContext('2d');
    //context.drawImage(image, 0, 0);
    //var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

    var imageData = qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg").replace(/^data:image\/(png|jpg|jpeg);base64,/, "");

    console.log(qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg"));
    window.DatecsPrinter.printImage(imageData, //base64
    150, 150, 1, function () {
      printMyText();
    }); //};
  };

  var printMyBarcode = function printMyBarcode(text) {
    var canvas = document.createElement("canvas");
    canvas.height = 400;
    canvas.width = 300;
    JsBarcode(canvas, text, {
      format: "CODE128",
      width: 2,
      height: 40
    });
    var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

    window.DatecsPrinter.printImage(imageData, //base64
    canvas.width, canvas.height, 1, function () {
      window.DatecsPrinter.printText("{BR} {BR} {BR} {BR} {CENTER}", 'ISO-8859-1');

      if (localStorage.getItem("printerName") == "Printer001") {
        window.DatecsPrinter.printText("{BR} {BR} {CENTER}", 'ISO-8859-1');
      }

      window.DatecsPrinter.printText("{BR}", 'ISO-8859-1');
      window.DatecsPrinter.writeHex('1B69'); //27,112,0,50,250
      // var open = new Uint8Array([27,112,0,50,250]);
      // window.DatecsPrinter.write(open);

      if (window.data.print == 0) window.DatecsPrinter.getStatus(); //THIS TO OPEN THE DRAWER

      $(".button-paid").blur();
      var report = localStorage.getItem("nickname") + ":" + window.data.orderID + ":" + window.data.total + ":" + "PAID";
      localStorage.setItem("report", localStorage.getItem("report"));

      if (window.origin == "bet_list") {
        $f7.views.main.router.back("/agent_betlist/");
      } else {
        if (window.service == "agent") $f7.views.main.router.navigate("/agent_home/");else {
          if (window.origin == "bet") $f7.views.main.router.navigate("/cashier_home/");else $f7.views.current.router.navigate("/cashier_pay/");
        }
      }
    });
  };

  var printReceipt = function printReceipt() {
    $f7.request({
      method: 'get',
      url: window.waypoint + 'print.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        orderId: window.data.orderID
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        if (!window.DatecsPrinter) {//alert("DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'");
        } else {
          window.bluetooth = localStorage.getItem("printercounterfeit");
          if (window.bluetooth == null || window.bluetooth == undefined) window.bluetooth = 0;
          window.DatecsPrinter.listBluetoothDevices(function (devices) {
            localStorage.setItem("printerName", devices[window.bluetooth].name);
            window.DatecsPrinter.connect(devices[window.bluetooth].address, function () {
              // if(window.service == "agent")
              // printMyText();
              // else
              //printMyImage();
              window.DatecsPrinter.printText("{BR}{CENTER}", 'ISO-8859-1');
              printMyQR();
              $f7.preloader.hide();
            }, function () {
              $f7.preloader.hide();
              alert(JSON.stringify(error));
            });
          }, function (error) {
            $f7.preloader.hide();
            alert(JSON.stringify(error));
          });
        }
      },
      error: function error() {
        $f7.preloader.hide();
      }
    });
  };

  var oneTime = false;

  var printPurchase = function printPurchase() {
    //PAID OPEN
    $(".button-paid").blur();
    $f7.preloader.show();

    if (window.copy || oneTime) {
      window.copy = true;
      printReceipt();
      return;
    }

    $(".button-paid").html("PRINT COPY");
    oneTime = true;
    $f7.request({
      method: 'get',
      url: window.waypoint + 'pay.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        orderId: window.data.orderID
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          //Print the receipt
          printReceipt();
          if (window.service == "agent") window.checkbalance = true;
        } else {
          $f7.dialog.alert(data.errMsg, "Error");
        }
      }
    }); //PAID CLOSE        
  };

  $on('pageInit', function () {
    //JsBarcode("#barcode","123456789012", {format: "EAN13",width:2});
    var raw = localStorage.getItem("receipt", raw);

    if (window.orderEntry != "") {
      for (var i = 20; i > 0; i--) {
        localStorage.setItem("history" + i, localStorage.getItem("history" + (i - 1)));
      }

      localStorage.setItem("history0", window.orderEntry);
    }

    raw = "\n      {\n        \"status\":\"1\", \n        \"orderId\":\"123456789012\", \n        \"receipt\":[{\"draw\":\"04/08/21 (WED)\",\"details\":[{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"GD\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]}]},{\"draw\":\"05/08/21 (THU)\",\"details\":[{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"GD\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]}]},{\"draw\":\"06/08/21 (FRI)\",\"details\":[{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"GD\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"GD\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]},{\"type\":\"SG\",\"number\":\"2345\",\"position\":\"(b24)\",\"amount\":[{\"type\":\"B\",\"value\":24.00},{\"type\":\"S\",\"value\":24.00},{\"type\":\"A\",\"value\":24.00}]},{\"type\":\"SG\",\"number\":\"1234\",\"position\":\"(i24)\",\"amount\":[{\"type\":\"B\",\"value\":1.00},{\"type\":\"S\",\"value\":1.00},{\"type\":\"A\",\"value\":1.00}]}]}], \n        \"remarks\":\"\", \n        \"page\":\"\",\n        \"print\":0,\n        \"dateTime\":\"2021-08-04 01:54PM\",\n        \"total\":486.00\n      }\n      ";
    /*
    {
        "status":"1",
        "receipts":[
          { "receipt":[{"draw":"04/09/21 (SAT)","details":[{"type":"GD","number":"1234","position":"","amount":[{"type":"B","value":5.00}]}]}], "orderID":"000000000000006E", "orderStatus":"11", "total":"0.000000", "currency":"USD", "print":"0", "gdCode":"", "dateTime":"Sep  4 2021  1:18PM"}]}
     */

    if (window.orderId == undefined || window.orderId == "") {
      $f7.dialog.alert('Empty Order ID', function () {
        $f7.views.current.router.back("/cashier_pay/");
      });
      return;
    } else {
      $f7.preloader.show();
    }

    $f7.request({
      method: 'get',
      url: window.waypoint + 'search.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        orderId: window.orderId
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        $f7.preloader.hide();
        console.log(data);
        var data = JSON.parse(data);
        window.data = data;
        console.log(data);
        console.log(data.total);
        var htmlText = '';

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          //CHECK IF PRINTED
          if (data.print > 1) {
            $(".button-paid").hide();
          } else {
            $(".button-paid").show();
          }

          if (data.orderStatus != "11") {
            window.copy = true;
            $(".button-paid").html("PRINT COPY");
          } else {
            window.copy = false;
            $(".button-paid").html("PAID");
          }

          htmlText = "\n              <div class=\"block\">\n                \n                <table width=100%>\n                  <thead>\n                    <tr>\n                      <th style=\"color:#555555;font-size:20px;font-weight:bold; text-align:left\">" + data.dateTime + "</th>\n                      <th style=\"color:#555555;font-size:20px;font-weight:bold; text-align:right\">" + data.orderID + "</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                  <tr>\n                      <td colspan=2><hr/></td>\n                  </tr>  \n              ";

          for (var i = 0; i < data.receipt.length; i++) {
            htmlText += "<tr><td colspan=2 style='font-size:16px;'><div style='background-color:#D6DBDF'>" + data.receipt[i].draw + "</div><table width=100%>";

            for (var j = 0; j < data.receipt[i].details.length; j++) {
              var amountType = "";

              for (var k = 0; k < data.receipt[i].details[j].amount.length; k++) {
                var numberType = data.receipt[i].details[j].amount[k].type;
                var numberValue = data.receipt[i].details[j].amount[k].value;

                if (numberValue == "0.00") {
                  numberType = "-";
                  numberValue = "----";
                }

                amountType += "<td style='font-size:16px;text-align:right'>" + numberType + "-" + numberValue + "</td>";
              }

              htmlText += "  \n                    <tr>\n                      <td style='font-size:16px'>" + data.receipt[i].details[j].type + "<span style='font-size:20px'><b> " + data.receipt[i].details[j].number + "</b></span></td>\n                      <td style='font-size:12px'>" + data.receipt[i].details[j].position + "</td> \n                      " + amountType + "\n                    </tr>   \n                  ";
            }

            htmlText += "</table></td></tr>";
          }

          console.log(data.total);
          $('.total').html(parseFloat(data.total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
          var gd6DJPNumber = "";

          for (var i = 0; i < data.gd6DJPNumber.length; i++) {
            gd6DJPNumber += "\n                  <tr><td colspan=2>" + data.gd6DJPNumber[i].date + "</td></tr>\n                ";

            for (var j = 0; j < data.gd6DJPNumber[i].number.length; j++) {
              gd6DJPNumber += "\n                  <tr><td colspan=2>" + data.gd6DJPNumber[i].number[j] + "</td></tr>\n                  ";
            }
          }

          var promo = "";

          if (data.promotionTitle != "" && data.promotionTitle != null) {
            promo = data.promotionTitle + "<br/>";

            for (var p = 0; p < data.promotionNumber.length; p++) {
              promo += "(" + data.promotionNumber[p].date + ") ";

              for (var q = 0; q < data.promotionNumber[p].number.length; q++) {
                promo += data.promotionNumber[p].number[q] + " ";
                console.log(data.promotionNumber[p].number[q]);
              }

              promo += "<br/>";
            }
          }

          var color1 = "";
          if (data.GDP == "--------") color1 = "style='color:red'";
          htmlText += "\n                  <tr><td colspan=2 " + color1 + ">GDP:" + data.GDP + "</td></tr> \n                  <tr><td colspan=2 " + color1 + ">" + data.gd4dJP + "</td></tr>\n                  <tr><td colspan=2 " + color1 + ">" + data.gd6dJP + "</td></tr>\n                  <tr><td colspan=2>" + gd6DJPNumber + "</td></tr>\n                  <tr><td colspan=2></td></tr>\n                  <tr><td colspan=2>" + promo + "</td></tr>\n                  </tbody>\n                </table>\n              </div>\n              ";
          $('.printtext').html(htmlText);
          $update();
        } else {
          $f7.dialog.alert('Order Not Found', function () {
            $f7.views.current.router.back("/cashier_pay/");
          });
        }
      },
      error: function error(data) {
        $f7.dialog.alert('Something wrong, data cannot be retrieved...', function () {
          $f7.views.current.router.back("/cashier_pay/");
        });
        $f7.preloader.hide();
      }
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Receipt</span>
        <span class='cn'>收据</span>
        <span class='tl'>Resibu</span>
      </div>
    </div>
  </div>

  
  <div class="page-content " style="background-color: white; color:black; height: 75%;">
    <!-- <div class="block-title block-title-large">Receipt</div> -->
    
    <div class="printtext">

    </div>
    <div id="qrcode" style="display:none;"></div>
    <div class="block">
      <div style="text-align: center;">
        <img id="barcode"/>
      </div>
    </div>
  </div>


  <div class="block" style="margin-top: 10px;">
    <table width=100%>
      <td style="text-align: left; font-size: 20px; font-weight: bold;" width=70%>
        TOTAL $<span class="total"></span>
      </td>
      <td>
        <button class="button button-fill button-paid" @click=${printPurchase} style="font-size: 20px; height: 50px;">PAID</button>
      </td>
    </table>
  </div>
  
</div>
`
    }
    ;
}

framework7Component.id = 'f62f007903';
export default framework7Component;